import sliceCreator from '../../index.jsx';
import {GET_REGION_BY_ID} from '../../../constants/index.jsx';
const _getRegionByIdAction = sliceCreator('GET_REGION_BY_ID', GET_REGION_BY_ID, 'get');

const { asyncAction: getRegionByIdAction, reducer, clearData: clearGetRegionByIdAction } = _getRegionByIdAction;

export default reducer;

export {
    getRegionByIdAction,
    clearGetRegionByIdAction
}